/**
 * Helpers URL purs pour ?lang= (#1452).
 * Pas d’import i18n / languageService — évite les cycles dans les tests MarketingHeader.
 */

const SUPPORTED = new Set([
  'en',
  'fr',
  'es',
  'de',
  'it',
  'nl-BE',
  'nl-NL',
  'nl',
]);

function normalizeLangParam(lang: string | null | undefined): string | null {
  if (!lang) return null;
  const trimmed = lang.trim().replace('_', '-');
  if (SUPPORTED.has(trimmed)) return trimmed;
  const base = trimmed.split('-')[0];
  if (SUPPORTED.has(base)) return base;
  return null;
}

/**
 * Ajoute / remplace `?lang=` sur un chemin d’auth (signup, login).
 * Préserve query existante (country, claim, …) et le hash.
 */
export function appendLangParam(
  path: string,
  lang: string | null | undefined
): string {
  const code = normalizeLangParam(lang);
  if (!code) return path;

  const hashIndex = path.indexOf('#');
  const hash = hashIndex >= 0 ? path.slice(hashIndex) : '';
  const withoutHash = hashIndex >= 0 ? path.slice(0, hashIndex) : path;
  const qIndex = withoutHash.indexOf('?');
  const pathname = qIndex >= 0 ? withoutHash.slice(0, qIndex) : withoutHash;
  const params = new URLSearchParams(
    qIndex >= 0 ? withoutHash.slice(qIndex + 1) : ''
  );
  params.set('lang', code);
  return `${pathname}?${params.toString()}${hash}`;
}

export function signupHrefForLocale(
  locale: string | null | undefined,
  extras?: { country?: string }
): string {
  const base = extras?.country
    ? `/signup-user?country=${extras.country}`
    : '/signup-user';
  return appendLangParam(base, locale);
}

export function loginPathForLocale(locale: string | null | undefined): string {
  return appendLangParam('/login', locale);
}
